(function($) {

    class PushLogic_GA4
    {
		constructor()
		{
			this.view_item();
			this.add_to_cart();
			this.begin_checkout();
			this.post_answer_submission();
			this.hidden_treasure();
		}
		
        view_item()
		{
			var view_item = $('.grid-view-item__link');
				
			view_item.on('click', function()
			{
				var current_link = $(this),
					product_id = current_link.data('product-id'),
					product_price = current_link.data('product-price'),
					product_name = current_link.data('product-name').replace(' - Download', '').replace(' - Printed', '').replace(' Download', '').replace(' Printed', '');

				gtag("event", "view_item", {currency: "GBP", value: product_price, items: [{item_id: product_id, item_name: product_name, price: product_price, quantity: 1}]});
			});
		}
		
		add_to_cart()
		{
			var add_to_cart = $('#btn_add_to_cart');
			
			add_to_cart.on('click', function()
			{
				var sku = $('.pltt-trail-select-item-active').data('value'),
					urlParams = new URLSearchParams(window.location.search),
					variant_id = urlParams.get('variant'),
					product_name = $('h1.product-single__title')[0],
					product_name = $(product_name).text().replace(' - Download', '').replace(' - Printed', '').replace(' Download', '').replace(' Printed', ''),
					product_base_price = $('.price-item--regular')[0],
					product_base_price = $(product_base_price).text().replace('£', ''),
					product_postage = $('.price__regular .postage-rate')[0],
					product_postage = $(product_postage).find('.rate-value').text(),
					final_price = parseFloat(product_base_price) + parseFloat(product_postage);

				if(sku == undefined)
				{
					sku = 'Download';
				}
				gtag("event", "add_to_cart", {currency: "GBP", value: final_price, items: [{item_id: variant_id, item_name: product_name, price: final_price, quantity: 1}]});
			});
		}
		
		begin_checkout()
		{
			if($('#your-shopping-basket').length > 0)
			{
				$.getJSON('/cart.js', function(cart) {
                    var basket_total = cart.items_subtotal_price/100,
                        basket_items = [];

                    $.each(cart.items, function(index, product_data)
                    {
                        basket_items.push({
                            item_id : product_data.variant_id,
                            item_name : product_data.title.replace(' - Download', '').replace(' - Printed', '').replace(' Download', '').replace(' Printed', ''),
                            price : product_data.price/100,
                            item_category : product_data.product_type,
                            quantity : product_data.quantity
                        });
                    });

					gtag("event", "begin_checkout", {
					  currency: cart.currency,
					  value: basket_total,
                      items: basket_items
					});
				});
			}
		}
		
		post_answer_submission()
		{
			if(sessionStorage.hasOwnProperty('pltt_post_answer_submit'))
			{
				var productcard_add_to_cart = $('.tt-add-to-cart'),
					product_add_to_cart = $('#btn_add_to_cart');

				if(productcard_add_to_cart.length > 0)
				{
					productcard_add_to_cart.on('click', function()
					{
						 $("<script>window.dataLayer = window.dataLayer || [];dataLayer.push({'event': 'pas_add_to_cart'});</script>").appendTo('head');
					});
				}

				if(product_add_to_cart.length > 0)
				{
					product_add_to_cart.on('click', function()
					{
						$("<script>window.dataLayer = window.dataLayer || [];dataLayer.push({'event': 'pas_add_to_cart'});</script>").appendTo('head');
					});
				}

				if(window.location.href.indexOf('submit-an-answer') > -1)
				{
					// Do Nothing...
				} else {
					$("<script>window.dataLayer = window.dataLayer || [];dataLayer.push({'event': 'pas_navigate_away'});</script>").appendTo('head');
				}
			}
		}
		
		hidden_treasure()
		{
			if(window.location.href.indexOf('hidden-treasure') > -1)
			{
				sessionStorage.setItem('pltt_hidden_treasure', 'active');
			}

			if(sessionStorage.hasOwnProperty('pltt_hidden_treasure'))
			{
				if(window.location.href.indexOf('/products/') > -1)
				{
					$("<script>window.dataLayer = window.dataLayer || [];dataLayer.push({'event': 'hidden_treasure_product_view'});</script>").appendTo('head');
				}
			}
		}
    }

    new PushLogic_GA4;
  
})(jQuery); 